const rings = [
  {
    "id": "ring-024",
    "name": "London Blue Topaz Trilogy Ring",
    "price": 23000,
    "description": "A striking London Blue Topaz centerpiece accented by six sparkling American Diamonds (CZ) in an elegant trilogy-inspired design.",
    "gem": "Topaz",
    "src": "/rings/RGR-023.webp",
    "details": {
      "gemstone": "London Blue Topaz",
      "carat": "Approx. 0.90 ct",
      "metal": "Gold Plated S925 Silver",
      "size": "Custom",
      "origin": "Sri Lanka",
      "certification": "Certified Authenticity"
    }
  },
  {
    "id": "ring-025",
    "name": "Almandine Garnet Trilogy Ring",
    "price": 23000,
    "description": "A rich Almandine Garnet centerpiece paired with six sparkling American Diamonds (CZ) in an elegant trilogy-inspired design.",
    "gem": "Garnet",
    "src": "/rings/RGR-025.webp",
    "details": {
      "gemstone": "Almandine Garnet",
      "carat": "Approx. 0.90 ct",
      "metal": "Gold Plated S925 Silver",
      "size": "Custom",
      "origin": "Sri Lanka",
      "certification": "Certified Authenticity"
    }
  },
  {
    "id": "ring-026",
    "name": "Almandine Garnet Solitaire Ring",
    "price": 20000,
    "description": "A rich Almandine Garnet showcased in a classic solitaire setting with a clean and elegant silhouette.",
    "gem": "Garnet",
    "src": "/rings/RGR-024.webp",
    "details": {
      "gemstone": "Almandine Garnet",
      "carat": "Not specified",
      "metal": "Rhodium Plated S925 Silver",
      "size": "Custom",
      "origin": "Sri Lanka",
      "certification": "Certified Authenticity"
    }
  },
  {
    id: "ring-022",
    name: "White Topaz Grace Ring",
    price: 32500,
    preorder: true,
    description: "Graceful Radiance — a brilliant white topaz centerpiece surrounded by sparkling white stones in an elegant gold-tone setting.",
    gem: "Topaz",
    src: "/rings/RGR-021.webp",
    details: {
      gemstone: "White Topaz",
      carat: "Approx. 2.0 ct",
      metal: "18K Gold Plated Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-023",
    name: "Pink Sapphire Infinity Ring",
    price: 45000,
    preorder: true,
    description: "Eternal Pink — two vivid pink sapphires embraced by an elegant infinity-inspired design with delicate sparkling accents.",
    gem: "Sapphire",
    src: "/rings/RGR-022.webp",
    details: {
      gemstone: "Natural Pink Sapphire",
      carat: "Approx. 0.75 ct",
      metal: "18K Rose Gold Plated Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-011",
    name: "Swiss Blue Topaz Halo Ring",
    price: 26000,
    preorder: true,
    description: "Sky Halo — a vivid Swiss blue topaz oval encircled by shimmering white stones.",
    gem: "Topaz",
    src: "/rings/RGR-008.webp",
    details: {
      gemstone: "Swiss Blue Topaz",
      carat: "2.25ct(Approx)",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-015",
    name: "Swiss Blue Topaz Trilogy Ring",
    price: 26000,
    description: "Swiss blue Whisper — a radiant Swiss Blue Topaz, beautifully paired 6 sparkling American Diamonds (CZ)",
    gem: "Topaz",
    src: "/rings/RGR-013.webp",
    details: {
      gemstone: "Swiss Blue Topaz",
      carat: "0.90 ct (approx)",
      metal: "Rhodium plated S925 Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-001",
    name: "Blue Spinal Promise Ring",
    price: 31000,
    preorder: true,
    description: "Midnight Spark — a rare blue spinel set in sterling silver, radiating deep oceanic hues.",
    gem: "Spinel",
    src: "/rings/RGR-012.webp",
    details: {
      gemstone: "Blue Spinel",
      carat: "0.85 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-016",
    name: "Sky Blue Topaz Bezel Ring",
    price: 20000,
    preorder: true,
    description: "Sky Blue Simplicity — a delicate Sky Blue Topaz in a timeless bezel setting. Crafted in 18K Gold Plated Silver for everyday elegance.",
    gem: "Topaz",
    src: "/rings/RGR-020.webp",
    details: {
      gemstone: "Sky Blue Topaz",
      carat: "Approx. 1.5 ct",
      metal: "18K Gold Plated Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-017",
    name: "Almandine Garnet Bezel Ring",
    price: 20000,
    preorder: true,
    description: "Crimson Glow — a rich Almandine Garnet showcased in a sleek bezel setting. Crafted in 18K Gold Plated Silver for a warm, luxurious finish.",
    gem: "Garnet",
    src: "/rings/RGR-019.webp",
    details: {
      gemstone: "Almandine Garnet",
      carat: "Approx. 0.80 ct",
      metal: "18K Gold Plated Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-018",
    name: "Sky Blue Topaz Pear Ring",
    price: 24000,
    preorder: true,
    description: "Sky Dew — a graceful pear-cut Sky Blue Topaz in a minimalist sterling silver bezel setting.",
    gem: "Topaz",
    src: "/rings/RGR-018.webp",
    details: {
      gemstone: "Sky Blue Topaz",
      carat: "Approx. 3.5 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-019",
    name: "London Blue Topaz Bezel Ring",
    price: 23000,
    preorder: true,
    description: "Ocean Midnight — a deep London Blue Topaz in a clean bezel setting, offering timeless sophistication.",
    gem: "Topaz",
    src: "/rings/RGR-017.webp",
    details: {
      gemstone: "London Blue Topaz",
      carat: "Approx. 2 ct",
      metal: "18K Gold Plated Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-020",
    name: "Sky Blue Topaz Solitaire Ring",
    price: 20000,
    preorder: true,
    description: "Crystal Sky — a sparkling oval Sky Blue Topaz set in a classic four-prong sterling silver solitaire.",
    gem: "Topaz",
    src: "/rings/RGR-016.webp",
    details: {
      gemstone: "Sky Blue Topaz",
      carat: "Approx. 0.90 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-021",
    name: "London Blue Topaz Princess Ring",
    price: 20000,
    preorder: true,
    description: "Midnight Square — a striking princess-cut London Blue Topaz in a refined four-prong sterling silver setting.",
    gem: "Topaz",
    src: "/rings/RGR-015.webp",
    details: {
      gemstone: "London Blue Topaz",
      carat: "Approx. 1.5 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-012",
    name: "Pink Tourmaline Swirl Ring",
    price: 25000,
    preorder: true,
    description: "Tourmaline promise — a soft pink tourmaline in an elegant swirl silver setting.",
    gem: "Tourmaline",
    src: "/rings/RGR-005.webp",
    details: {
      gemstone: "Pink Tourmaline",
      carat: "0.95 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-013",
    name: "Yellow Sapphire Promise Ring",
    price: 42000,
    deal: true,
    originalPrice: 47000,
    description: "Sapphire Warmth, Timeless Grace — a radiant natural yellow sapphire full of sunshine.",
    gem: "Sapphire",
    src: "/rings/RGR-006.webp",
    details: {
      gemstone: "Natural Yellow Sapphire",
      carat: "0.80 ct",
      metal: "18K Gold Plated Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-002",
    name: "Brown Tourmaline Promise Ring",
    price: 35000,
    preorder: true,
    description: "A piece of the earth, shaped into a promise — warm earth tones captured in tourmaline.",
    gem: "Tourmaline",
    src: "/rings/RGR-011.webp",
    details: {
      gemstone: "Brown Tourmaline",
      carat: "1.10 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-003",
    name: "Iolite Promise Ring",
    price: 18500,
    preorder: true,
    description: "For the one who feels like your Cinderella — violet-blue iolite in a delicate silver setting.",
    gem: "Iolite",
    src: "/rings/RGR-010.webp",
    details: {
      gemstone: "Iolite",
      carat: "0.90 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-004",
    name: "London Blue Topaz Halo Ring",
    price: 36000,
    preorder: true,
    description: "London Blue Grace — deep ocean hue blue topaz encircled by a sparkling diamond halo.",
    gem: "Topaz",
    src: "/rings/RGR-014.webp",
    details: {
      gemstone: "London Blue Topaz",
      carat: "2.0 ct (approx)",
      metal: "Rhodium plated S925 Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-005",
    name: "Green Tourmaline Halo Ring",
    price: 32000,
    preorder: true,
    description: "Forest Glow — a vivid green tourmaline embraced by a brilliant white halo setting.",
    gem: "Tourmaline",
    src: "/rings/RGR-002.webp",
    details: {
      gemstone: "Green Tourmaline",
      carat: "1.15 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-006",
    name: "Moonstone Solitaire Ring",
    price: 29500,
    preorder: true,
    description: "A blue angel dances inside a piece of the moon — adularescent moonstone with a floating glow.",
    gem: "Moonstone",
    src: "/rings/RGR-003.webp",
    details: {
      gemstone: "Blue Moonstone",
      carat: "1.05 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-007",
    name: "Blue Sapphire Halo Ring",
    price: 57000,
    preorder: true,
    description: "Royal Aura — a deep blue sapphire commanding attention from its brilliant diamond halo throne.",
    gem: "Sapphire",
    src: "/rings/RGR-004.webp",
    details: {
      gemstone: "Natural Blue Sapphire",
      carat: "1.10 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-010",
    name: "Pink Sapphire Solitaire Ring",
    price: 60500,
    preorder: true,
    description: "Forever Framed in Pink — a vivid natural pink sapphire solitaire, one of Sri Lanka's finest.",
    gem: "Sapphire",
    src: "/rings/RGR-007.webp",
    details: {
      gemstone: "Natural Pink Sapphire",
      carat: "0.75 ct",
      metal: "Sterling Silver (925)",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  },

  {
    id: "ring-014",
    name: "Garnet Marquise Ring",
    price: 25500,
    preorder: true,
    description: "Golden Ember — a deep red garnet marquise flanked by two sparkling white stones on a warm gold band.",
    gem: "Garnet",
    src: "/rings/RGR-009.webp",
    details: {
      gemstone: "Alamandine Garnet",
      carat: "0.80 ct",
      metal: "18K Gold Plated Silver",
      size: "Custom",
      origin: "Sri Lanka",
      certification: "Certified Authenticity"
    }
  }

];

export default rings;